import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Administration icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Administration } from '@sravni/design-system-icons'
 *
 * <Administration />
 * ```
 */
var Administration = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Administration", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.667 17.5H3.333c-.92 0-1.666-.746-1.666-1.667V4.167c0-.921.746-1.667 1.666-1.667h13.334c.92 0 1.666.746 1.666 1.667v11.666c0 .921-.745 1.667-1.666 1.667ZM1.667 6.667h16.666", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M3.982 4.575c-.002 0-.004.002-.004.004 0 .003.002.004.004.004.003 0 .005-.001.005-.004 0-.002-.002-.004-.005-.004ZM6.102 4.575c-.003 0-.005.002-.005.004 0 .003.003.004.005.004s.004-.001.004-.004c0-.002-.002-.004-.004-.004ZM8.217 4.575c-.002 0-.004.002-.004.004 0 .003.002.004.005.004.002 0 .004-.001.004-.004 0-.002-.002-.004-.005-.004ZM11.425 11.667v-1.075c0-.901-.926-1.7-1.923-1.335-.573.21-.926.794-.926 1.404v1.006", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M11.667 14.583H8.333a.834.834 0 0 1-.833-.833V12.5c0-.46.373-.833.833-.833h3.334c.46 0 .833.373.833.833v1.25c0 .46-.373.833-.833.833Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Administration };
//# sourceMappingURL=Administration.js.map
